

































import Vue, { PropType } from "vue";
import { ContinuePrompt } from "@/store/ContinuePrompts";
import { isoLanguageCodes } from "@/store/Languages";

export default Vue.extend({
  props: {
    data: Object as PropType<ContinuePrompt>,
    langCode: String as PropType<isoLanguageCodes>,
    dir: String as PropType<"ltr" | "rtl">
  },
  mounted: function() {
    Vue.nextTick(() => {
      (this.$refs.confirmButton as HTMLButtonElement).focus();
    });
  },
  methods: {
    userCancelled: function() {
      this.$emit("user-cancel");
    },
    userConfirmed: function() {
      this.$emit("user-confirm");
    },
    keyboardHandler: function(e: KeyboardEvent) {
      if (e.keyCode === 27) {
        this.userCancelled();
        return;
      }
      const firstFocusableEl = this.$refs.cancelButton as HTMLButtonElement;
      const lastFocusableEl = this.$refs.confirmButton as HTMLButtonElement;
      if (e.keyCode === 9) {
        if (e.shiftKey && document.activeElement === firstFocusableEl) {
          e.preventDefault();
          lastFocusableEl.focus();
        } else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
          e.preventDefault();
          firstFocusableEl.focus();
        }
      }
    }
  }
});
